import { gql } from '@apollo/client/core';

export default gql`
  query TaxonomyProjectSpreadsheets($projectId: String!) {
    getTaxonomyProjectSpreadsheets(projectId: $projectId)
  }
`;
